import GlobalUtils from '@/lib/utils/global-utils';

export const debounce = () => {
  let h: number;
  return (func: () => void, wait = 50) => {
    window.clearTimeout(h);
    h = window.setTimeout(() => func(), wait);
  };
};

export const clone = object => {
  if (typeof object === 'undefined') {
    return {};
  }
  return JSON.parse(JSON.stringify(object));
};

export const checkFileName = (filename: string) => {
  const fileRegex = /[^a-zA-Z0-9-_.]/g;
  let updatedTitle = filename.replace(/ /g, '_').replace(fileRegex, '');
  updatedTitle = updatedTitle.replace(/\.[^/.]+$/, '');

  const maxFileNameLength = 100;
  if (updatedTitle.length > maxFileNameLength) {
    updatedTitle = updatedTitle.substring(0, maxFileNameLength);
  }
  return updatedTitle;
};

export const scriptInjector = ({
  src,
  attach = true,
  body = true,
  module = false
}): HTMLScriptElement => {
  if (!src) {
    GlobalUtils.assert(src == null, 'should not happen');
  }
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  if(module){
    script.type = "module"
  }
  if (attach) {
    body
      ? document.body.appendChild(script)
      : document.head.appendChild(script);
  }
  return script;
};

export const forwardPageWheel = (event: WheelEvent, scroller?: HTMLElement | null) => {
  const target = event.target as HTMLElement;
  if (!scroller || !target || !target.closest || scroller.contains(target)) return;
  if (event.ctrlKey || event.shiftKey || !event.deltaY) return;
  if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

  let node: HTMLElement | null = target;
  while (node && node !== event.currentTarget) {
    const maxScroll = node.scrollHeight - node.clientHeight;
    const overflowY = window.getComputedStyle(node).overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      maxScroll > 0 &&
      (event.deltaY > 0 ? node.scrollTop < maxScroll : node.scrollTop > 0)
    ) {
      return;
    }
    node = node.parentElement;
  }

  let delta = event.deltaY;
  if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 16;
  if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
    delta *= scroller.clientHeight || window.innerHeight;
  }
  scroller.scrollTop += delta;
  event.preventDefault();
};
